





























































































































import Vue from "vue";
import { axios } from "@/plugins";
import { Form } from "element-ui";

const RuleForm = {
  alertTargetId: "",
  projectId: "",
  objName: "",
  ruleItem: [] as { type: string; maxRate: string; forMinute: string }[]
};

const RuleOptions = [
  { label: "事件告警", value: "EVENT" },
  { label: "CPU使用比例", value: "CPU" },
  { label: "内存使用比例", value: "MEMORY" }
];

const TargetTypeOption = [
  {
    label: "钉钉",
    value: "DINGTALK"
  },
  {
    label: "邮箱",
    value: "EMAIL"
  },
  {
    label: "短信",
    value: "SMS"
  }
];

export default Vue.extend({
  name: "Edit",
  data() {
    return {
      isEdit: false,
      dialog: false,
      loading: false,
      loadType: "Deployment",
      form: {
        ...RuleForm,
        ruleItem: [{ type: "EVENT", maxRate: "80", forMinute: "1" }] as {
          type: string;
          maxRate: string;
          forMinute: string;
        }[]
      },
      rules: {
        alertTargetId: [
          { required: true, message: "请选择接收人", trigger: "change" }
        ],
        objName: [{ required: true, message: "请选择组件", trigger: "change" }],
        ruleItem: [
          {
            required: true,
            message: "请添加一条告警规则",
            type: "array",
            min: 1
          }
        ]
      },
      targetOption: [],
      appOptions: [],
      RuleOptions
    };
  },
  props: {
    projectId: { type: String },
    tenantId: { type: String }
  },
  computed: {
    header() {
      // @ts-ignore
      return this.isEdit ? "编辑告警规则" : "创建告警规则";
    },
    filterAppOptions() {
      // @ts-ignore
      return this.appOptions.filter(
        // @ts-ignore
        (option: any) => option.loadType === this.loadType
      );
    }
  },
  mounted() {
    // @ts-ignore
    this.getAppOptions();
    // @ts-ignore
    this.getTarget();
  },
  methods: {
    show(data?: any) {
      console.log(data);

      if (data) {
        // @ts-ignore
        this.isEdit = true;
        // @ts-ignore
        this.form = { ...data };
      } else {
        // @ts-ignore
        this.form.projectId = this.projectId;
      }
      // @ts-ignore
      this.dialog = true;
    },
    // 添加告警规则
    addRule() {
      if (!this.form.ruleItem) {
        this.form.ruleItem = [];
      }
      // @ts-ignore
      this.form.ruleItem.push({
        type: "EVENT",
        maxRate: "80",
        forMinute: "1"
      });
    },
    delRule(index: number) {
      if (this.form.ruleItem.length === 1) return;
      this.form.ruleItem.splice(index, 1);
    },
    getTarget() {
      // @ts-ignore
      axios.get(`/alerttarget/${this.tenantId}`).then(res => {
        // @ts-ignore
        this.targetOption = res.data.data;
      });
    },
    // 负载类型切换响应
    getAppOptions() {
      // @ts-ignore
      axios.get(`/project/${this.projectId}/component`).then(res => {
        // @ts-ignore
        this.appOptions = res.data.data;
      });
    },
    getTypeName(type: string) {
      const data = TargetTypeOption.find(item => item.value === type);
      if (data) {
        return data.label;
      }
    },
    quit() {
      // @ts-ignore
      this.dialog = false;
      setTimeout(() => {
        this.form = {
          ...RuleForm,
          ruleItem: [{ type: "EVENT", maxRate: "80", forMinute: "1" }]
        };
        this.$nextTick((this.$refs.form as Form).clearValidate);
        // @ts-ignore
        this.isEdit = false;
        // @ts-ignore
        this.loadType = "Deployment";
      }, 200);
    },
    submit() {
      (this.$refs.form as any).validate((valid: any) => {
        if (valid) {
          // @ts-ignore
          this.loading = true;
          // @ts-ignore
          if (this.isEdit) {
            // @ts-ignore
            this.edit();
          } else {
            // @ts-ignore
            this.create();
          }
        }
      });
    },
    create() {
      axios
        // @ts-ignore
        .post(`/alertrule`, this.form)
        .then(() => {
          this.$message.success("告警规则创建成功");
          // @ts-ignore
          this.quit();
          this.$emit("afterEdit");
        })
        .finally(() => {
          // @ts-ignore
          this.loading = false;
        });
    },
    edit() {
      axios
        // @ts-ignore
        .put(`/alertrule`, this.form)
        .then(() => {
          this.$message.success("告警规则修改完成");
          // @ts-ignore
          this.quit();
          this.$emit("afterEdit");
        })
        .finally(() => {
          // @ts-ignore
          this.loading = false;
        });
    }
  }
});
